<div class="card">
  <div class="card-header pb-0">
    <div class="media-space-between">
      <h5>{{ "admin.history.title" | translate }}</h5>
      <div class="media-body">
        <form class="d-inline-flex" [formGroup]="formFilter">
          <app-date-range-picker
            [form]="formFilter | asFormGroup"
            inputFormControlName="date"
          ></app-date-range-picker>
          <app-search-field
            [form]="formFilter | asFormGroup"
            [filterOptions]="historyFilter"
            [placeholder]="'placeholder.search' | translate"
            inputFormControlName="emailOrNameOrCompanyName"
            (emitSelectedOptions)="saveOptionFilter($event)"
          ></app-search-field>
          <button
            class="btn btn-primary m-l-10"
            type="button"
            (click)="removeFilter()"
          >
            <i class="fa fa-repeat me-2"></i>
            {{ "buttons.removeFilter" | translate }}
          </button>
          <div style="margin-left: 10px">
            <app-refresh-button [state]="fetchingHistoryState" [date]="cachedAt" (buttonClick)="invokeHistory(true)"></app-refresh-button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="table-responsive data-table">
      <form>
        <table class="table table-striped table-border-vertical">
          <thead>
            <tr>
              <th>{{ "admin.history.fullName" | translate }}</th>
              <ng-container *ngFor="let column of sortedColumns">
                <th
                  sortable
                  sortable="{{ column.key }}"
                  (sort)="onSort($event)"
                >
                  {{ column.label | translate }}
                </th>
              </ng-container>
              <ng-container *ngFor="let column of columns">
                <th>
                  {{ column.label | translate }}
                </th>
              </ng-container>
              <ng-container *ngFor="let column of dateColumn">
                <th
                  sortable
                  sortable="{{ column.key }}"
                  (sort)="onSort($event)"
                >
                  {{ column.label | translate }}
                </th>
              </ng-container>
            </tr>
          </thead>
          <tbody *ngIf="!loading">
            <tr *ngFor="let history of historyResult.history">
              <td>{{ history.firstName }} {{ history.lastName }}</td>
              <td>
                {{ history.email }}
              </td>
              <td>
                {{ history.companyName }}
              </td>
              <td>
                {{ history.subRoleName }}
              </td>
              <td>
                {{ history.ipAddress }}
              </td>
              <td *ngIf="history.action">
                <span
                  [ngClass]="
                    'badge ' +
                    badgeService.getBadgeForActionLogger(history.action)
                  "
                >
                  {{
                    "enumMapping.history.action." + history.action | translate
                  }}
                </span>
              </td>
              <td>
                {{ "userHistoryServices." + history.endPoint | translate }}
              </td>
              <td>
                {{ history.creationDate | localizedDate : "short" }}
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="forbidden" class="d-flex justify-content-center m-t-20">
          {{ "response.error.FORBIDDEN_RESPONSE" | translate }}
        </div>
        <div
          *ngIf="historyResult.count == 0 && !loading && !forbidden"
          class="d-flex justify-content-center m-t-20"
        >
          {{ "noData" | translate }}
        </div>
        <div *ngIf="loading && !forbidden">
          <ng-container style="float: right" class="flex">
            <div class="loader-box">
              <div class="loader-34"></div>
            </div>
            <h6
              class="col align-self-center f-w-600"
              style="text-align: center"
            >
              {{ "fetching" | translate }}
            </h6>
          </ng-container>
        </div>
      </form>
    </div>
    <app-pager
      [count]="historyResult.count"
      [pageSize]="pageSize"
      [pageNumber]="pageNumber"
      (emitChangePage)="changePage($event)"
      (emitChangePageSize)="itemsPerPageChange($event)"
    ></app-pager>
  </div>
</div>
